import {
  AutoComplete,
  Button,
  Radio,
  Collapse,
  Form,
  Input,
  Select,
  Spin,
  TreeSelect,
  Row,
  Col,
  Divider
} from "antd";
import React, { useContext, useState, useEffect } from "react";
import { NomenclatureContext } from "../../lib/hooks/context/getNomenclatureContext";
import { useForm } from "antd/es/form/Form";
import { useSearchParams } from "react-router-dom";
import { DeleteOutlined, SearchOutlined} from "@ant-design/icons";

const { Panel } = Collapse;

const FilterNomenclature = ({ isOpen }) => {
  const { token, categoriesData } = useContext(NomenclatureContext);
  const [optionsCategories, setOptionsCategories] = useState([]);
  const [globalCategoriesTree, setGlobalCategoriesTree] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setLoading] = useState(false);
  const [form] = useForm();

  
  useEffect(() => {
    const loadGlobalCategoriesTree = async () => {
      try {
        const res = await fetch(
          `https://${process.env.REACT_APP_APP_URL}/api/v1/mp/categories/tree-select/`,
        );
        const data = await res.json();
        if (data?.result) {
          setGlobalCategoriesTree(data.result);
        }
      } catch (err) {
        console.error("Ошибка загрузки дерева глобальных категорий:", err);
      }
    };
    if (isOpen) {
      loadGlobalCategoriesTree();
    }
  }, [isOpen]);

  
  useEffect(() => {
    setOptionsCategories(
      (categoriesData || []).map((i) => ({
        value: i.name,
        label: i.name,
        key: i.id,
      }))
    );
  }, [categoriesData]);

  
  useEffect(() => {
    if (!isOpen) return;

    const prepare = async () => {
      const formValues = {};
      searchParams.forEach((value, name) => {
        if (name === "category") {
          const category = categoriesData?.find((i) => i.id === value);
          if (category) {
            formValues[name] = category.name;
          }
        } else if (name === "has_photos") {
          
          if (value === "true") formValues.has_photos = true;
          else if (value === "false") formValues.has_photos = false;
          else formValues.has_photos = null;
        } else if (name === "tags") {
          
          formValues.tags = value.split(",").map(t => t.trim()).filter(Boolean);
        } else if (name === "chatting_percent" || name === "global_category_id") {
          formValues[name] = Number(value);
        } else if (!isNaN(value) && value !== "" && name !== "token") {
          formValues[name] = Number(value);
        } else {
          formValues[name] = value;
        }
      });
      form.setFieldsValue(formValues);
    };

    prepare();
  }, [isOpen, searchParams, categoriesData, form]);

  const searchHandler = async (values) => {
    const processedValues = { ...values };

    
    if (processedValues.category) {
      const category = optionsCategories.find((i) => i.value === processedValues.category);
      if (category) {
        processedValues.category = category.key;
      } else {
        delete processedValues.category;
      }
    }

    
    if (Array.isArray(processedValues.tags) && processedValues.tags.length) {
      processedValues.tags = processedValues.tags.join(",");
    } else {
      delete processedValues.tags;
    }

    
    if (processedValues.has_photos === null || processedValues.has_photos === undefined) {
      delete processedValues.has_photos;
    } else {
      processedValues.has_photos = processedValues.has_photos === true ? "true" : "false";
    }

    
    Object.keys(processedValues).forEach((key) => {
      if (
        processedValues[key] === undefined ||
        processedValues[key] === null ||
        processedValues[key] === "" ||
        (Array.isArray(processedValues[key]) && processedValues[key].length === 0)
      ) {
        delete processedValues[key];
      }
    });

    setLoading(true);
    setSearchParams({
      token,
      limit: 10,
      offset: 0,
      ...processedValues,
    });
    setLoading(false);
  };

  const resetFields = () => {
    form.resetFields();
    setSearchParams({
      token,
      limit: 10,
      offset: 0,
    });
  };

  
  const tagOptions = [
    { value: "хит", label: "Хит" },
    { value: "новинка", label: "Новинка" },
    { value: "распродажа", label: "Распродажа" },
    { value: "эксклюзив", label: "Эксклюзив" },
  ];

  return (
    <Collapse
      className="nomenclature-filter-collapse"
      activeKey={isOpen ? ["1"] : []}
      ghost
      style={{ margin: "2px 0 0 0", width: "100%" }}
    >
      <Panel header={null} key="1" showArrow={false} style={{ paddingLeft: 0 }}>
        <Form
          layout="vertical"
          form={form}
          onFinish={searchHandler}
          style={{ width: "100%" }}
        >
          <Row gutter={[24, 16]}>
            {/* Основные поля */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="name" label="Название">
                <Input placeholder="Введите название" allowClear />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="description_long" label="Описание">
                <Input placeholder="Введите описание" allowClear />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="category" label="Категория товара">
                <AutoComplete
                  options={optionsCategories}
                  allowClear
                  placeholder="Выберите категорию"
                  filterOption={(inputValue, option) =>
                    option?.label?.toLowerCase().includes(inputValue.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="global_category_id" label="Глобальная категория">
                <TreeSelect
                  treeData={globalCategoriesTree}
                  placeholder="Выберите глобальную категорию"
                  treeDefaultExpandAll={false}
                  showSearch
                  allowClear
                  treeLine
                  filterTreeNode={(input, node) =>
                    (node?.title || "").toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>

            {/* Теги */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="tags" label="Теги">
                <Select
                  mode="tags"
                  placeholder="Введите теги (нажмите Enter)"
                  options={tagOptions}
                  allowClear
                  tokenSeparators={[","]}
                />
              </Form.Item>
            </Col>

            {/* Наличие фото — три состояния */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="has_photos" label="Наличие фото">
                <Radio.Group buttonStyle="solid" style={{ width: "100%" }}>
                  <Radio.Button value={null} style={{ width: "33%", textAlign: "center" }}>
                    Все
                  </Radio.Button>
                  <Radio.Button value={true} style={{ width: "33%", textAlign: "center" }}>
                    С фото
                  </Radio.Button>
                  <Radio.Button value={false} style={{ width: "33%", textAlign: "center" }}>
                    Без фото
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>

            {/* Комиссия платформы */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="chatting_percent" label="Комиссия платформы">
                <Input
                  type="number"
                  placeholder="%"
                  addonAfter="%"
                  allowClear
                />
              </Form.Item>
            </Col>

            {/* Дополнительные поля (можно добавить позже) */}
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="min_price" label="Мин. цена">
                <Input type="number" placeholder="0" allowClear />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Form.Item name="max_price" label="Макс. цена">
                <Input type="number" placeholder="10000" allowClear />
              </Form.Item>
            </Col>
          </Row>

          <Divider style={{ margin: "12px 0" }} />

          <Row justify="end" gutter={12}>
            <Col>
              <Button
                icon={<DeleteOutlined />}
                danger
                onClick={resetFields}
                style={{ marginRight: 8 }}
              >
                Очистить
              </Button>
            </Col>
            <Col>
              <Form.Item shouldUpdate style={{ marginBottom: 0 }}>
                {() => (
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={isLoading ? <Spin size="small" /> : <SearchOutlined />}
                    loading={isLoading}
                  >
                    Поиск
                  </Button>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Panel>
    </Collapse>
  );
};

export default FilterNomenclature;